import createReactClass from 'create-react-class';

export default function ({ language, tools, InputField }) {
  var config = {
    autoComplete: 'postal-code',
    label: language['zip-label'],
    placeholder: '1234',
    format: 'integer',
    maxLength: 4,
    api: {
      errorMessage: language['zip-error'],
    },
    validators: ['mandatory', 'numberOfDigits:4', 'onlyDigits'],
    behaviour: 'text-input',
  };

  var Zip = createReactClass({
    render() {
      var field = this.props.field;
      var apiStatus = field.state.api;
      return (
        <div className="lz-input-wrapper">
          <label htmlFor={tools.uniqueId(field.config.id)}>{field.config.label}</label>
          <span className="lz-extratext">{field.config.tinyLabel}</span>
          <div className="lz-table lz-table-middle">
            <div className="lz-table-cell lz-cell-1-2">
              <div
                className={`lz-input ${this.props.errorClass} ${
                  (field.config.style && field.config.style.lz_input) || ''
                }`}
              >
                <div className={this.props.spinnerClass}>
                  <i className="fa fa-spinner fa-spin"></i>
                </div>
                <div className="lz-checkmark">
                  <i className="fa fa-check"></i>
                </div>
                <InputField
                  config={field.config}
                  state={field.state}
                  onUpdate={this.props.onUpdate}
                  index={this.props.index}
                />
                <span className="lz-input-bar"></span>
              </div>
              {this.props.errors}
            </div>
            <div className="lz-table-cell lz-cell-1-2">{this.getAreaCode()}</div>
          </div>
        </div>
      );
    },
    getAreaCode() {
      var field = this.props.field;
      var apiStatus = field.state.api;
      var showAreaCode = !(field.state.errors.length || apiStatus.running);
      return (
        <div className={'lz-areacode' + (showAreaCode ? ' is-visible' : '')}>
          <span>{apiStatus.result.poststed || apiStatus.result.city}</span>
        </div>
      );
    },
  });

  return {
    html: Zip,
    config: config,
  };
}
